import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import defaultValue from '../news/defaultValue.js';
var View = function View() {
  return import('./View.vue');
};
var Form = function Form() {
  return import('../news/Form.vue');
};
export default {
  defaultValue: defaultValue,
  View: View,
  Form: Form
};